import { render, staticRenderFns } from "./newsCenList.vue?vue&type=template&id=5f3c19c6&scoped=true&"
import script from "./newsCenList.vue?vue&type=script&lang=js&"
export * from "./newsCenList.vue?vue&type=script&lang=js&"
import style1 from "./newsCenList.vue?vue&type=style&index=1&id=5f3c19c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3c19c6",
  null
  
)

export default component.exports